import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

/**
 * Whether the admin's session has run out and they're being asked to sign in
 * again. Kept apart from AdminSessionService (which needs AuthService) so any
 * card can read it: a load that failed because of it says so, and tries again
 * once the admin is back.
 */
@Injectable({ providedIn: 'root' })
export class AdminSessionState {
  private readonly expiredSubject = new BehaviorSubject(false);
  private readonly signedInAgainSubject = new Subject<void>();

  /** True while the "Your session expired" prompt is open. */
  readonly expired$ = this.expiredSubject.asObservable();
  /** The admin signed in again from that prompt, on the page they were on. */
  readonly signedInAgain$ = this.signedInAgainSubject.asObservable();

  get expired(): boolean {
    return this.expiredSubject.value;
  }

  setExpired(expired: boolean): void {
    if (this.expiredSubject.value !== expired) this.expiredSubject.next(expired);
  }

  signedInAgain(): void {
    this.setExpired(false);
    this.signedInAgainSubject.next();
  }
}
